import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';
import {
  DriverConfigType,
  DriverInfo,
  FirestoreDriver,
  FireStoreRuleSet,
  ProfileInfo,
} from 'src/features/profile/types';
import { FetchDutyStatusPayload, ChangeDutyStatusPayload } from 'src/common/types';

const initialState: ProfileInfo = {
  driver: {
    phone: '',
    email: '',
    status: '',
    status_display: '',
    middle_name: '',
    drivers_license_number: '',
    drivers_license_issuing_state: '',
    drivers_license_cdl_type: '',
    drivers_license_expiration_date: '',
    permissions: [],
    employeeId: 0,
    userId: 0,
    companyId: 0,
    firstName: '',
    lastName: '',
    createdOn: '',
    lastUpdated: '',
    activeGroup: 0,
    timeZone: '',
  },
  dutyStatus: {
    dutyStatusCode: 0,
    dutyStatusName: '',
  },
  dutyStatusSuccess: false,
  driverConfig: {
    employeeId: 0,
    createOn: '',
    updatedOn: null,
    activeRuleset: '',
    driversLicenseNumber: null,
    driversLicenseIssuingState: null,
    DHTTimezone: '',
  },
};

export const profileReducerSlice = createSlice({
  name: 'profileReducer',
  initialState,
  reducers: {
    setDriverInfo: (state, action: PayloadAction<DriverInfo>): void => {
      state.driver = action.payload;
    },
    setDutyStatus: (state, action): void => {
      state.dutyStatus = action.payload;
    },
    setDutyStatusSuccess: (state, action): void => {
      state.dutyStatusSuccess = action.payload;
    },
    setDriverConfig: (state, action: PayloadAction<DriverConfigType>): void => {
      state.driverConfig = action.payload;
    },
    setFirestoreDriver: (state, action: PayloadAction<FirestoreDriver>): void => {
      state.firestoreDriver = action.payload;
    },
    setFirestoreRuleset: (state, action: PayloadAction<FireStoreRuleSet>): void => {
      state.firestoreRuleset = action.payload;
    },
  },
});

export const {
  setDriverInfo,
  setDutyStatus,
  setDutyStatusSuccess,
  setDriverConfig,
  setFirestoreDriver,
  setFirestoreRuleset,
} = profileReducerSlice.actions;

export const fetchDriverInfo = createAction('profile/fetchDriverInfo');
export const fetchDutyStatusLogs = createAction<FetchDutyStatusPayload>('auth/fetchDutyStatusLogs');
export const changeDutyStatus = createAction<ChangeDutyStatusPayload>('profile/changeDutyStatus');
export const fetchDriverConfig = createAction<number>('profile/fetchDriverConfig');

export default profileReducerSlice.reducer;
